(() => {
  if (window.cartCountBubbleUpdater) return;

  class CartCountBubbleUpdater {
    constructor() {
      this.requestNumber = 0;
      this.refreshTimer = undefined;
      this.handleCartUpdate = () => this.scheduleRefresh();
      this.handleRebuyCartUpdate = () => this.scheduleRefresh(100);
      this.handlePageShow = (event) => {
        if (event.persisted) this.scheduleRefresh();
      };

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate);
      }

      document.addEventListener('rebuy:cart.change', this.handleRebuyCartUpdate);
      window.addEventListener('pageshow', this.handlePageShow);
    }

    scheduleRefresh(delay = 0) {
      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.refresh(), delay);
    }

    async refresh() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      const requestNumber = ++this.requestNumber;
      const cartUrl = window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
      const separator = cartUrl.includes('?') ? '&' : '?';

      try {
        const response = await fetch(`${cartUrl}${separator}section_id=cart-icon-bubble`, {
          headers: { Accept: 'text/html' },
          cache: 'no-store'
        });

        if (!response.ok) return;

        const html = await response.text();
        if (requestNumber !== this.requestNumber) return;

        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const renderedSection =
          documentFragment.querySelector('#shopify-section-cart-icon-bubble') ||
          documentFragment.querySelector('.shopify-section');

        if (!renderedSection) return;

        const renderedBubble = renderedSection.querySelector('.cart-count-bubble');
        cartLink.innerHTML = renderedSection.innerHTML;

        document.querySelectorAll('.menu-drawer__utility-account-cart').forEach((container) => {
          const existingBubble = container.querySelector('.cart-count-bubble');

          if (renderedBubble) {
            if (existingBubble) {
              existingBubble.replaceWith(renderedBubble.cloneNode(true));
            } else {
              container.append(renderedBubble.cloneNode(true));
            }
          } else if (existingBubble) {
            existingBubble.remove();
          }
        });
      } catch (error) {
        console.error('Unable to update cart count.', error);
      }
    }
  }

  window.cartCountBubbleUpdater = new CartCountBubbleUpdater();
})();
